module.exports = "<div class=\"container page-actions\">\n  <div class=\"top__info\">\n    <a href=\"#\" class=\"top_left_item\" *ngFor=\"let item of menu; let i = index;\" [ngClass]=\"menu[i].class\" [textContent]=\"menu[i].title\"\n      rtb-rooftop-item [attr.id]=\"menu[i].id\" (sendMsgEvent)=\"SelectRooftops($event)\"></a>\n\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/rtb/up-menu/up-menu.component.html
// module id = ./src/app/components/rtb/up-menu/up-menu.component.html
// module chunks = main